export const TENURES = [7, 15, 30, 60, 90];
export const AMOUNT_MIN = 5000;
export const AMOUNT_MAX = 100000;
export const AMOUNT_STEP = 500;
export const DAILY_RATE = 0.001;
export const FEE_RATE = 0.025;
export const FEE_MIN = 399;
export const GST_RATE = 0.18;

export const inr = (n) =>
  new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', maximumFractionDigits: 0 }).format(n);

export function buildQuote(amount, tenureDays) {
  const interest = Math.round(amount * DAILY_RATE * tenureDays);
  const fee = Math.max(Math.round(amount * FEE_RATE), FEE_MIN);
  const gst = Math.round(fee * GST_RATE);
  return {
    amount,
    tenure_days: tenureDays,
    interest,
    processing_fee: fee,
    gst_on_fee: gst,
    total_repayment: amount + interest + fee + gst,
    apr_pct: (DAILY_RATE * 365 * 100).toFixed(1),
  };
}

export function dueDate(days, locale = 'en-IN') {
  return new Intl.DateTimeFormat(locale, { day: 'numeric', month: 'short', year: 'numeric' }).format(
    new Date(Date.now() + days * 86400000)
  );
}
